import { SVGProps, Ref, forwardRef } from 'react';

export const BuildingOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M7.1 19.4H4.5v-1.8h2.6z" fill="currentColor" />
        <path d="M11.5 19.4H8.9v-1.8h2.6z" fill="currentColor" />
        <path d="M7.1 15.9H4.5v-1.8h2.6z" fill="currentColor" />
        <path d="M11.5 15.9H8.9v-1.8h2.6z" fill="currentColor" />
        <path d="M7.1 12.4H4.5v-1.8h2.6z" fill="currentColor" />
        <path d="M11.5 12.4H8.9v-1.8h2.6z" fill="currentColor" />
        <path d="M7.1 8.9H4.5V7.1h2.6z" fill="currentColor" />
        <path d="M11.5 8.9H8.9V7.1h2.6z" fill="currentColor" />
        <path d="M7.1 5.4H4.5V3.6h2.6z" fill="currentColor" />
        <path d="M11.5 5.4H8.9V3.6h2.6z" fill="currentColor" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 7h8v9c0 3.771 0 5.657-1.172 6.828-1.025 1.025-2.596 1.154-5.5 1.17L15 24H8v-.002h-.328c-2.8-.015-4.362-.136-5.389-1.063l-.111-.107c-1.025-1.025-1.154-2.596-1.17-5.5L1 16V0h14zM2.8 16c0 1.936.004 3.208.13 4.15.12.889.319 1.21.514 1.406.196.195.517.394 1.407.513.941.127 2.213.131 4.149.131h4.2V1.8H2.8zM15 10.6h4.5v1.8H15v1.7h4.5v1.8H15v1.7h4.5v1.8H15v2.8c1.936 0 3.208-.004 4.15-.13.889-.12 1.21-.319 1.406-.514.195-.196.394-.517.513-1.407.127-.941.131-2.213.131-4.149V8.8H15z"
            fill="currentColor"
        />
    </svg>
));
BuildingOutlinedSize24Glyph.displayName = 'BuildingOutlinedSize24Glyph';
